import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";
import { Reveal } from "./anim";

export default function Intimacy() {
  const { t } = useLang();
  const c = t.intimacy;

  return (
    <section className="relative py-24 md:py-36 bg-cream-2" data-testid="intimacy-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-[1.1fr_0.9fr] gap-14 lg:gap-24 items-center">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-brand mb-6">{c.overline}</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.1] tracking-tight text-ink">
            {c.title}
          </h2>
          <p className="mt-8 font-light text-base sm:text-lg leading-relaxed text-ink-soft max-w-xl">
            {c.text}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="grid grid-cols-2 gap-4">
            <div className="clip-frame">
              <img src={IMAGES.candles} alt="" className="w-full h-[300px] md:h-[380px] object-cover" />
            </div>
            <div className="clip-frame mt-10">
              <img src={IMAGES.oil} alt="" className="w-full h-[300px] md:h-[380px] object-cover" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
